









import Component from 'vue-class-component'
import { Vue } from 'vue-property-decorator'
import Limit from '@/dto/limits/Limit'
import LimitFactory from '@/services/factories/LimitFactory'
import LimitForm from '@/components/limit/LimitForm.vue'

@Component({
  components: { LimitForm },
})
export default class LimitCreate extends Vue {
  limit: Limit = LimitFactory()
}
